import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Layout from './Partials/Layout';
import { ArrowLeft, Info } from './Helpers/icons/Icons';

export default function Failure() {
  const { t } = useTranslation();

  return (
    <Layout>
      <div className='flex min-h-[560px] items-center bg-canvas py-20'>
        <div className='container-x'>
          <div className='mx-auto max-w-[520px] rounded-card border border-line bg-paper p-8 text-center md:p-12'>
            <span className='mx-auto mb-7 flex h-16 w-16 items-center justify-center rounded-pill bg-pomegranate-100 text-pomegranate-700'>
              <Info size={30} />
            </span>

            <h1 className='display-md'>{t('payment_failed')}</h1>
            <p className='lede mt-4'>{t('payment_failed_message')}</p>

            <div className='mt-9 flex flex-wrap justify-center gap-3'>
              <Link to='/products' className='btn btn-ink'>
                <ArrowLeft size={16} />
                {t('gift_cards')}
              </Link>
              <Link to='/contact' className='btn btn-outline'>
                {t('contact_us')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
